

















































































































import Vue from "vue";
import Component from "vue-class-component";
import axios from "axios";
import AbstractDialog from "./components/dialog/AbstractDialog.vue";
import CitationDialog from "./components/dialog/CitationDialog.vue";

const overlayState = Vue.observable({ show: false });

@Component({
  components: {
    AbstractDialog,
    CitationDialog,
  },
})
export default class App extends Vue {
  sidebarShown = false;
  showAbstractDialog = false;
  showCitationDialog = false;
  get overlayShown() {
    return overlayState.show;
  }

  constructor() {
    super();
    axios.interceptors.request.use(function (config: any) {
      overlayState.show = true;
      return config;
    });
    axios.interceptors.response.use(function (config: any) {
      overlayState.show = false;
      return config;
    });
    document.title = "RTFC";
  }
}
